import React, { useState } from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer id="footer" className="bg-[#0A5E5C] text-white pt-20 pb-10" data-id="element-156">
        <div className="container mx-auto px-4" data-id="element-157">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-158">
            {/* Brand Column */}
            <div className="lg:col-span-1" data-id="element-159">
              <div className="flex items-center gap-2 mb-6" data-id="element-160">
                <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center" data-id="element-161">
                  <span className="text-[#D4A843] font-serif font-bold text-lg" data-id="element-162">
                    FG
                  </span>
                </div>
                <span className="text-xl font-serif font-bold" data-id="element-163">
                  Fair Gaming Space
                </span>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-164">
                Ми захищаємо права гравців та сприяємо розвитку чесного ігрового
                ринку в Україні. Приєднуйтесь до нашої спільноти.
              </p>
              <div className="flex gap-4" data-id="element-165">
                <a href="https://www.facebook.com/share/14bkTnc99Km/?mibextid=wwXIfr" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-166">
                  <Facebook size={18} data-id="element-167" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-168">
                  <Twitter size={18} data-id="element-169" />
                </a>
                <a href="https://www.instagram.com/olenavodolazhko?igsh=bHJjNTRjcWwzb2dl" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-170">
                  <Instagram size={18} data-id="element-171" />
                </a>
                <a href="https://www.linkedin.com/in/olena-vodolazhko-372ab576?utm_source=share_via&utm_content=profile&utm_medium=member_ios" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-172">
                  <Linkedin size={18} data-id="element-173" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-174">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-175">
                Швидкі посилання
              </h3>
              <ul className="space-y-3" data-id="element-176">
                {[{
                name: 'Головна',
                target: 'hero'
              }, {
                name: 'Про нас',
                target: 'founder'
              }, {
                name: 'Активності',
                target: 'activities'
              }, {
                name: 'Новини',
                target: 'news'
              }, {
                name: 'Контакти',
                target: 'footer'
              }].map(item => <li key={item.name} data-id="element-177">
                    <button onClick={() => {
                  const el = document.getElementById(item.target);
                  if (el) {
                    const headerOffset = 80;
                    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                      top: elementPosition - headerOffset,
                      behavior: 'smooth'
                    });
                  }
                }} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-178">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-179" />
                      {item.name}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-180">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-181">
                Інформація
              </h3>
              <ul className="space-y-3" data-id="element-182">
                <li data-id="element-183">
                  <button onClick={() => setActiveModal('privacy')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-184">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-185" />
                    Політика конфіденційності
                  </button>
                </li>
                <li data-id="element-186">
                  <button onClick={() => setActiveModal('terms')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-187">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-188" />
                    Умови використання
                  </button>
                </li>
                {['Звітність', 'Для преси', 'Вакансії'].map(item => <li key={item} data-id="element-189">
                    <a href="#" className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-190">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-191" />
                      {item}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Contact Info */}
            <div data-id="element-192">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-193">
                Контактна інформація
              </h3>
              <ul className="space-y-4" data-id="element-194">
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-195">
                  <Mail size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-196" />
                  <span data-id="element-197">fgsukraine@gmail.com</span>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-198">
                  <Phone size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-199" />
                  <span data-id="element-200">+38 (067) 403 2026</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-201">
            <p data-id="element-202">© 2024 Простір Чесної Гри. Всі права захищені.</p>
            <p data-id="element-203">Розроблено з любов'ю до чесної гри</p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {activeModal === 'privacy' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-204">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-205" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-206">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-207">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-208">
                Політика конфіденційності
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-209">
                <X className="w-5 h-5" data-id="element-210" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-211">
              <div className="text-center mb-4" data-id="element-212">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-213">
                  КОМПЛЕКСНА ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ ТА ЗАХИСТУ ДАНИХ
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-214">
                  ГО «Простір чесної гри»
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-215">
                  Редакція: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-216">
                <div data-id="element-217">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-218">
                    1. Загальні положення
                  </h5>
                  <p data-id="element-219">
                    Ця Політика визначає порядок обробки та захисту персональних
                    даних ГО «Простір чесної гри» (FAIR Gaming Space).
                    Організація діє відповідно до Закону України «Про захист
                    персональних даних», а також застосовує принципи GDPR та UK
                    GDPR у разі взаємодії з резидентами ЄС або Великої Британії.
                  </p>
                </div>
                <div data-id="element-220">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-221">
                    2. Принципи обробки даних
                  </h5>
                  <p data-id="element-222">
                    Обробка здійснюється на принципах законності, прозорості,
                    обмеження мети, мінімізації даних, точності, обмеження
                    строків зберігання та забезпечення цілісності й
                    конфіденційності.
                  </p>
                </div>
                <div data-id="element-223">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-224">
                    3. Категорії даних
                  </h5>
                  <p data-id="element-225">
                    Ім'я, email, організація, IP-адреса, технічні дані,
                    відповіді на дослідницькі анкети, а також знеособлені або
                    псевдонімізовані дані.
                  </p>
                </div>
                <div data-id="element-226">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-227">
                    4. Правові підстави (GDPR Art. 6, 9)
                  </h5>
                  <p data-id="element-228">
                    Згода суб'єкта даних; законний інтерес; виконання статутних
                    завдань; виконання юридичних зобов'язань. Спеціальні
                    категорії даних обробляються виключно на підставі явної
                    згоди та з належними гарантіями.
                  </p>
                </div>
                <div data-id="element-229">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-230">
                    5. Міжнародна передача даних
                  </h5>
                  <p data-id="element-231">
                    У разі передачі даних за межі України або ЄС застосовуються
                    Standard Contractual Clauses (SCC) або інші передбачені
                    законом механізми захисту.
                  </p>
                </div>
                <div data-id="element-232">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-233">
                    6. Data Processing Agreement (DPA)
                  </h5>
                  <p data-id="element-234">
                    У разі залучення підрядників (хостинг, email-сервіси, CRM)
                    укладаються договори про обробку даних (DPA), що
                    встановлюють обов'язки процесора щодо безпеки та
                    конфіденційності.
                  </p>
                </div>
                <div data-id="element-235">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-236">
                    7. Cookies Policy
                  </h5>
                  <p data-id="element-237">
                    Сайт використовує обов'язкові, аналітичні та функціональні
                    cookies. Користувач може керувати згодою через банер або
                    налаштування браузера.
                  </p>
                </div>
                <div data-id="element-238">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-239">
                    8. Data Breach Response Procedure
                  </h5>
                  <p data-id="element-240">
                    У разі порушення безпеки даних Організація здійснює
                    внутрішнє розслідування, вживає заходів для мінімізації
                    ризиків та повідомляє компетентні органи та суб'єктів даних
                    у строки, передбачені законодавством.
                  </p>
                </div>
                <div data-id="element-241">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-242">
                    9. Призначення DPO
                  </h5>
                  <p data-id="element-243">
                    Організація може призначити відповідальну особу з питань
                    захисту даних (Data Protection Officer), яка контролює
                    відповідність законодавству та приймає звернення суб'єктів
                    даних.
                  </p>
                </div>
                <div data-id="element-244">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-245">
                    10. Права суб'єктів даних
                  </h5>
                  <p data-id="element-246">
                    Право на доступ, виправлення, видалення, обмеження обробки,
                    перенесення даних, відкликання згоди та подання скарги до
                    наглядового органу.
                  </p>
                </div>
                <div data-id="element-247">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-248">
                    11. UK & US Compliance Block
                  </h5>
                  <p data-id="element-249">
                    У разі співпраці з UK або US грантодавцями Організація
                    дотримується вимог UK GDPR, UK Data Protection Act, а також
                    забезпечує відповідність міжнародним стандартам безпеки
                    даних та антикорупційного законодавства (UK Bribery Act,
                    FCPA).
                  </p>
                </div>
                <div data-id="element-250">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-251">
                    12. Строки зберігання
                  </h5>
                  <p data-id="element-252">
                    Дані зберігаються не довше, ніж це необхідно для досягнення
                    мети обробки та виконання законодавчих або грантових вимог.
                  </p>
                </div>
                <div data-id="element-253">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-254">
                    13. Оновлення політики
                  </h5>
                  <p data-id="element-255">
                    Актуальна версія Політики завжди публікується на офіційному
                    вебсайті.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms of Use Modal */}
      {activeModal === 'terms' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-256">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-257" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-258">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-259">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-260">
                Умови використання
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-261">
                <X className="w-5 h-5" data-id="element-262" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-263">
              <div className="text-center mb-4" data-id="element-264">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-265">
                  УМОВИ ВИКОРИСТАННЯ
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-266">
                  ГО «Простір чесної гри» / FAIR Gaming Space
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-267">
                  Редакція: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-268">
                <div data-id="element-269">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-270">
                    1. Загальні положення
                  </h5>
                  <p data-id="element-271">
                    Ці Розширені Умови використання регулюють доступ та
                    використання вебсайту Громадської організації «Простір
                    чесної гри» (FAIR Gaming Space) (далі — Організація).
                    Використовуючи Сайт, Користувач підтверджує повну згоду з
                    цими Умовами. Організація має право змінювати Умови без
                    попереднього повідомлення.
                  </p>
                </div>
                <div data-id="element-272">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-273">
                    2. Незалежність та неафілійованість
                  </h5>
                  <p data-id="element-274">
                    Організація є незалежною неприбутковою структурою. Вона не
                    здійснює гральну діяльність, не афілійована з операторами
                    азартних ігор, не отримує affiliate-винагород та не просуває
                    комерційні послуги операторів.
                  </p>
                </div>
                <div data-id="element-275">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-276">
                    3. Research Integrity Clause
                  </h5>
                  <p data-id="element-277">
                    Усі дослідження проводяться незалежно, відповідно до
                    принципів академічної доброчесності, методологічної
                    прозорості та добровільної участі. Донори не впливають на
                    результати досліджень.
                  </p>
                </div>
                <div data-id="element-278">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-279">
                    4. Інформаційний характер матеріалів
                  </h5>
                  <p data-id="element-280">
                    Матеріали Сайту мають інформаційний, аналітичний та освітній
                    характер. Вони не є юридичною, медичною або фінансовою
                    консультацією. Організація не несе відповідальності за
                    рішення, прийняті Користувачем на підставі матеріалів Сайту.
                  </p>
                </div>
                <div data-id="element-281">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-282">
                    5. Реєстрація та участь у дослідженнях
                  </h5>
                  <p data-id="element-283">
                    Користувач може реєструватися для отримання новин або участі
                    в дослідженнях. Участь у дослідженнях є добровільною та
                    базується на принципі інформованої згоди.
                  </p>
                </div>
                <div data-id="element-284">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-285">
                    6. Донати та фінансова прозорість
                  </h5>
                  <p data-id="element-286">
                    Добровільні внески є безповоротною благодійною допомогою.
                    Організація забезпечує прозору фінансову звітність та може
                    проходити незалежний аудит.
                  </p>
                </div>
                <div data-id="element-287">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-288">
                    7. Антикорупційні та санкційні положення
                  </h5>
                  <p data-id="element-289">
                    Організація дотримується законодавства України, міжнародних
                    антикорупційних стандартів, UK Bribery Act та FCPA (у разі
                    міжнародного фінансування). Не приймаються кошти від
                    підсанкційних осіб або структур.
                  </p>
                </div>
                <div data-id="element-290">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-291">
                    8. Інтелектуальна власність
                  </h5>
                  <p data-id="element-292">
                    Усі матеріали Сайту захищені законодавством про
                    інтелектуальну власність. Комерційне використання без
                    письмового дозволу заборонене.
                  </p>
                </div>
                <div data-id="element-293">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-294">
                    9. Захист персональних даних
                  </h5>
                  <p data-id="element-295">
                    Обробка персональних даних здійснюється відповідно до Закону
                    України «Про захист персональних даних» та принципів GDPR (у
                    разі міжнародної взаємодії).
                  </p>
                </div>
                <div data-id="element-296">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-297">
                    10. Обмеження відповідальності
                  </h5>
                  <p data-id="element-298">
                    Організація не гарантує безперебійну роботу Сайту та не несе
                    відповідальності за технічні перебої або дії третіх осіб.
                  </p>
                </div>
                <div data-id="element-299">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-300">
                    11. Застосовне право
                  </h5>
                  <p data-id="element-301">До цих Умов застосовується законодавство України.</p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}